module.exports = __webpack_public_path__ + "img/close_ico_4.a40c0836.svg";